import { data } from '../../svg/LeftPanelClose/data';
import { makeIcon } from '../makeIcon';

export const LeftPanelClose = makeIcon(data, 'left_panel_close', 'LeftPanelClose');

export default LeftPanelClose;
